document.addEventListener('DOMContentLoaded', initAffiliateLogin);

function initAffiliateLogin() {
  const root = document.querySelector('[data-affiliate-login]');
  if (!root) return;

  const signInPanel = root.querySelector('[data-affiliate-login-panel="sign-in"]');
  const resetPanel = root.querySelector('[data-affiliate-login-panel="reset"]');
  const showResetBtn = root.querySelector('[data-affiliate-show-reset]');
  const showSignInBtn = root.querySelector('[data-affiliate-show-sign-in]');

  function showPanel(name) {
    if (signInPanel) signInPanel.hidden = name !== 'sign-in';
    if (resetPanel) resetPanel.hidden = name !== 'reset';
  }

  if (showResetBtn) {
    showResetBtn.addEventListener('click', () => showPanel('reset'));
  }

  if (showSignInBtn) {
    showSignInBtn.addEventListener('click', () => showPanel('sign-in'));
  }

  if (resetPanel?.querySelector('.affiliate-login__alert--success')) {
    showPanel('reset');
  }

  root.querySelectorAll('[data-affiliate-password-toggle]').forEach((btn) => {
    const input = btn.closest('.affiliate-login__password-wrap')?.querySelector('[data-affiliate-password-input]');
    const showIcon = btn.querySelector('[data-affiliate-password-icon-show]');
    const hideIcon = btn.querySelector('[data-affiliate-password-icon-hide]');
    if (!input) return;

    btn.addEventListener('click', () => {
      const visible = input.type === 'text';
      input.type = visible ? 'password' : 'text';
      if (showIcon) showIcon.hidden = !visible;
      if (hideIcon) hideIcon.hidden = visible;
      btn.setAttribute('aria-label', visible ? 'Show password' : 'Hide password');
    });
  });

  if (resetPanel && !resetPanel.hidden) {
    showPanel('reset');
  } else if (window.location.hash === '#recover') {
    showPanel('reset');
  }
}
